
import { format, utcToZonedTime } from 'date-fns-tz';

// types
import { User } from 'types/interface'

// /*
// */ Data user
// 

// data user
export const extractDataUser = ({
    id,
    fullName,
    email,
    role,
    blockedAt,
    stats: { confirmedIncidents, reportedIncidents },
    notifications: { isEnabled, location, radius },
    registeredAt,
  }: User) => {

    let locationName = location?.name;
    let translateRole = translationRole( role );
    let translateblockedAt = translationblockedAt( blockedAt );    
    let notificationsEnabled = isEnabled !== null ? translationNotifications(isEnabled) : false;

    let dateTimeregisteredAt = utcToZonedTime(registeredAt, 'Europe/Bratislava');
    let formattedregisteredAt = format(dateTimeregisteredAt, 'dd.MM.yyyy HH:mm');

    return {
      id,
      fullName,
      email,
      role: translateRole,
      blockedAt: translateblockedAt,
      confirmedIncidents,
      reportedIncidents,
      notificationsIsEnabled: notificationsEnabled,
      location: locationName,
      radius,
      registeredAt: formattedregisteredAt,
    };
  };

  

// translate role eng => sk
const translationRole = ( userRole: string ) => {
    if ( userRole && userRole === 'visitor' ) {
        return 'Návštevník';
    } else if ( userRole && userRole === 'specialist' ) {
        return 'Odborník';
    } else if ( userRole && userRole === 'admin' ) {
        return 'Administrátor';
    }
}

// translate state eng => sk
const translationblockedAt = ( blockedAt: string | null ) => {
    return ( blockedAt === null ) ? "Aktívny" : "Blokovaný";
}

// translate notifications enabled eng => sk
const translationNotifications = ( notificationsIsEnabled: boolean ) => {
    return ( notificationsIsEnabled === true ) ? "Zapnuté" : "Vypnuté";
}
  

// export data
const Data = {
  extractDataUser,
};
  
  export default Data;
